import type { MittwaldAPIV2Client } from "@mittwald/api-client-NEXT";
import { assertStatus } from "@mittwald/api-client-NEXT";
import type { RedisBehaviors } from "./types.js";

export const apiRedisBehaviors = (
  client: MittwaldAPIV2Client,
): RedisBehaviors => ({
  find: async (redisDatabaseId) => {
    const response = await client.database.getRedisDatabase({
      redisDatabaseId,
    });
    if (response.status === 200) {
      return response.data;
    }
    assertStatus(response, 404);
  },

  list: async (projectId) => {
    const response = await client.database.listRedisDatabases({
      projectId,
    });
    assertStatus(response, 200);
    return {
      items: response.data,
    };
  },

  create: async (projectId, data) => {
    const response = await client.database.createRedisDatabase({
      projectId,
      data,
    });
    assertStatus(response, 201);
    return response.data;
  },

  listVersions: async (projectId) => {
    const response = await client.database.listRedisVersions({
      queryParameters: { projectId },
    });
    assertStatus(response, 200);
    return response.data;
  },

  delete: async (redisDatabaseId) => {
    const response = await client.database.deleteRedisDatabase({
      redisDatabaseId,
    });
    assertStatus(response, 204);
  },

  updateDescription: async (redisDatabaseId, description) => {
    const response = await client.database.updateRedisDatabaseDescription({
      redisDatabaseId,
      data: { description },
    });
    assertStatus(response, 204);
  },

  updateConfiguration: async (redisDatabaseId, data) => {
    const response = await client.database.updateRedisDatabaseConfiguration({
      redisDatabaseId,
      data: { configuration: data },
    });
    assertStatus(response, 204);
  },
});
